import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { IIconProps } from "../icon";

export const CaffeineIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 72 72" {...rest}>
      <title>{t("icons.caffeine")}</title>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons/Big/Koffein">
          <g
            id="Group"
            transform="translate(14.000000, 3.000000)"
            stroke={props.fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path
              d="M38.7159421,46.9547429 L40.2519837,46.9547429 C46.1853448,46.9483723 50.9937172,42.0727857 51,36.0564846 C50.9937311,33.192883 48.7058857,30.8730568 45.8817613,30.8667002 L39.2289059,30.8667002"
              id="Path"
            ></path>
            <path
              d="M39.2289059,35.0191057 L45.8817613,35.0191057 C46.4470225,35.0191057 46.9054778,35.4833224 46.906264,36.0564846 C46.9023373,39.7812638 43.9254135,42.7998007 40.2519837,42.8037823 L39.0949654,42.8037823"
              id="Path"
            ></path>
            <path
              d="M0.00427469826,30.5502852 L0.00427469826,41.8444235 C-0.101909691,48.0710036 2.86232702,53.9408989 7.90676688,57.4932417 C10.3154601,59.1177616 13.1415578,59.9893991 16.0343932,60 L23.0862204,60 C25.9771129,59.9882687 28.8010723,59.1166795 31.2081471,57.4932417 C36.2525869,53.9408989 39.2168236,48.0710036 39.1106392,41.8444235 L39.1106392,30.5502852"
              id="Path"
            ></path>
            <path
              d="M19.5567445,24.1381852 C8.75600693,24.1381852 0,27.0090376 0,30.5502852 C0,34.0915329 8.75600693,36.9609404 19.5567445,36.9609404 C30.3574821,36.9609404 39.1120641,34.0915329 39.1120641,30.5502852 C39.1120641,27.0090376 30.3617568,24.1381852 19.5567445,24.1381852 Z"
              id="Path"
            ></path>
            <path
              d="M37.0830074,33.4009101 C33.8883829,31.2842525 27.2512014,29.8249868 19.5567445,29.8249868 C11.8622877,29.8249868 5.22938087,31.2842525 2.03048167,33.4009101 C5.23080577,35.5117885 11.8736869,36.9609404 19.5567445,36.9609404 C27.2398022,36.9609404 33.8798335,35.5117885 37.0830074,33.4009101 Z"
              id="Path"
            ></path>
            <path
              d="M24.2555031,7.34256246 C24.2555031,7.34256246 21.1534971,8.87984826 23.222451,12.7245076 C25.291405,16.5691669 23.222451,18.8736508 23.222451,18.8736508"
              id="Path"
            ></path>
            <path
              d="M16.6907121,0 C16.6907121,0 13.588706,1.53873062 15.6562351,5.38194513 C17.7237642,9.22515964 15.6562351,11.5325332 15.6562351,11.5325332"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
